export default __webpack_public_path__ + "static/esgReport2021-0d2f59dc3c7b8bda361ceaa5a638fd07.pdf";